<template>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex row middle">
          <div class="flex-1 w100">
            <div v-if="false" class="flex end filters-group-holder row">
              <div style="margin-right: 16px;" class="flex column no-mobile">
                <label>Atualizar dados</label>
                <div class="flex end w100" style="margin-top:12px">
                  <div @click="forceRefreshData()" class="button secondary">
                    <i class="fas fa-sync-alt"></i>
                  </div>
                </div>
              </div>

              <ltk-date-picker
                style="margin-right: 16px;"
                label="Filtro de data"
                v-model="filters.data.date"
                :loading="loading"
              ></ltk-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="w100">
        <div class="flex margin-top-l">
          <div class="flex-1">
            <div class="box">
              <div class="box-content">
                <div class="flex middle row">
                  <div class="flex-1 flex column middle margin-top-s">
                    <p>Seu link para divulgação de venda:</p>
                    <div v-if="checkStatusAwaiting" class="margin-top-s"> 
                      <h3>{{ linkSale }}<span class="copy" @click="copyInfo(linkSale)"><i class="far fa-copy"></i></span></h3>
                    </div>
                    <div v-else class="margin-top-s">
                      <small>Estamos gerando seu link de parceiro.</small>
                    </div>
                  </div>
                  <div v-if="false" class="flex-2 flex column middle margin-top-s">
                    <p>Seu cupom de desconto:</p>
                    <div v-if="checkStatusAwaiting" class="margin-top-s">
                      <h3>{{ account.external_cupom_code }}<span class="copy" @click="copyInfo(account.external_cupom_code)"><i class="far fa-copy"></i></span></h3>
                    </div>
                    <div v-else class="margin-top-s">
                      <small>Estamos gerando seu cupom de parceiro.</small>
                    </div>
                  </div>
                  <div class="flex-1 flex column middle margin-top-s">
                    <p>Taxa de Comissionamento:</p>
                    <div class="margin-top-s">
                      <h3>{{ account.plan }}: {{ account.tax_rate_commission | number }}%</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex row margin-top-l">
          <div class="flex-1 margin-right-8px" >
            <box-info
              icon="fas fa-users"
              label="Vendas Aprovadas"
              tooltip="Total de vendas pagas no mês atual."
              :value="report.approved_sales_count"
              :money="false"
              currency="BRL"
            >
            </box-info>
          </div>

          <div class="flex-1">
            <box-info
              icon="fas fa-dollar-sign"
              label="Valor em Comissões de VENDAS"
              tooltip="Somatório de comissões de todas as vendas do mês atual."
              :value="report.approved_sales_sum"
              :money="true"
              currency="BRL"
            >
            </box-info>
          </div>
        </div>

        <div v-if="false" class="flex row">
          <div class="flex-1 margin-right-8px" >
            <box-info
              icon="fas fa-list"
              label="Saldo a liberar"
              tooltip="Total em comissões com menos de 30 dias. Ou seja, valor em comissões de vendas com menos de 30 dias. Você precisa esperar esse saldo liberar"
              :value="report.mycredit_to_be_released"
              :money="true"
              currency="BRL"
            >
            </box-info>
          </div>

          <div class="flex-1">
            <box-info
              icon="fas fa-piggy-bank"
              label="Saldo pronto para saque"
              tooltip="Total em comissões com mais de 30 dias. Ou seja, valor em comissões de vendas com mais de 30 dias. Você pode solicitar o saque para esse valor"
              :value="report.mycredit_to_withdraw"
              :money="true"
              currency="BRL"
            >
            </box-info>
          </div>
        </div>

        <div class="margin-top-m" style="padding-left: 8px">
          <small><b>Atenção:</b> Todas as informações de <b>VENDA</b> são referentes ao mês atual.</small>
        </div>

        <div class="grid-flex wrap w100">
          <div class="item flex-1 center-txt">
            <div class="box2 ">
              <div class="box-content2 custom-card">
                <div class="flex row">
                  <custom-line
                    class="margin-top-l w100"
                    :data="levelChart"
                  ></custom-line>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="flex margin-top-l">
          <div class="flex-1">
            <div class="box">
              <div class="box-content">
                <div class="flex middle center">
                  <div class="banner">
                    <img src="@/assets/img/banner.jpg"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

    </section>
</template>

<script>

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";
import boxInfo from "@/components/boxInfo/BoxInfo";

import { 
  getWithdraws,
} from "@/services/withdraw";

import { 
  getSales
} from "@/services/sale";

import customLine from "./customLine";
import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";

const emptyData = {
  approved_sales_count: '-',
  approved_sales_sum: '-',
  mycredit_to_be_released: '-',
  mycredit_to_withdraw: '-',
  approved_sales_count_last_30_days: '-'
};

export default {
  name: "report",
  components: {
    ltkDatePicker,
    boxInfo,
    customLine
  },
  data() {
    return {
      loading: false,
      isTvMode: false,
      refreshTime: 60, // 60s refresh data
      refreshInterval: null,
      report: Object.assign({}, emptyData),
      filters: {
        data: {
          date: [
            moment()
              .add(-30, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {
        },
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    levelChart() {
      let _levels_map = {
        'INICIANTE': { min: 0, max: 30, percent: 20, next: 'INTERMEDIARIO' },
        'INTERMEDIARIO': { min: 31, max: 65, percent: 24, next: 'EXPERT' },
        'EXPERT': { min: 66, max: 120, percent: 26, next: 'DIAMANTE' },
        'DIAMANTE': { min: 121, max: 500, percent: 30, next: null },
      }

      let _atual_level = _levels_map[this.account.plan]
      if (!_atual_level) {
        return {}
      }

      let _next_level = _levels_map[_atual_level.next] 

      // get sales in last 30 days
      let result = { }

      let _meta_atual = this.report.approved_sales_count_last_30_days * 100 / _next_level.min

      let _meta_next_level = 100 - _meta_atual

      // result[`Meta ${this.account.plan}`] = _meta_atual
      result[`Suas Vendas`] = _meta_atual
      result[`Meta para próximo nível`] = _meta_next_level

      return result
    },
    checkStatusAwaiting() {
      return this.account && this.account.status !== 'AWAITING_EXTERNAL'
    },
    linkSale() {
      return `https://p.parceirospapainoel.com/${this.account.external_cupom_code}`
    }
  },
  watch: {
    "filters.data.date": {
      deep: true,
      handler() {
        this.stats = emptyData;
        this.getReport();
      },
    },
  },
  mounted() {
    this.getReport()
    this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000)

  },
  methods: {
    async copyInfo(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$toast.success({
          title:'Sucesso',
          message:'Informação Copiada'
        })
      } catch($e) {
        this.$toast.error({
          title:'Erro',
          message:'Falha ao copiar'
        })
      }
    },
    forceRefreshData() {
      this.stats = emptyData;
      this.getReport();
    },
    calMediaValue(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'].reduce((t, n) => n + t , 0) / data[index]['data'].length
    },
    lastValueDataset(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'][data[index]['data'].length - 1]
    },
    calDiffPercent(value1, value2) {
      if (!value1 || !value2) {
        return ''
      }

      let calDiff = value1 / value2
      calDiff = (calDiff - 1)  * 100
      calDiff = this.$options.filters.number(calDiff)

      if (value1 > value2) {
        return `<span style="color:green;">${calDiff}%</span>`
      }

      return `<span style="color:red;">${calDiff}%</span>`
    },
    getReport() {
      if (this.loading) {
        return
      }
      this.loading = true;
      getWithdraws()
        .then((result) => {
          this.report.mycredit_to_be_released = result.report.mycredit_to_be_released;
          this.report.mycredit_to_withdraw = result.report.mycredit_to_withdraw;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
        });

      getSales()
        .then((result) => {
          this.report.approved_sales_count = result.report.sale_count;
          this.report.approved_sales_sum = result.report.sale_sum;
          this.report.approved_sales_count_last_30_days = result.report.sales_count_last_30_days;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
        });

        
    },
  },
}
</script>

<style lang="scss" scoped>

.banner {
  img {
    max-width: 1024px;
    border-radius: 8px;
  }
}
.copy {
  margin-left: 16px;
  color: var(--primary);
  cursor: pointer;
}

.margin-right-8px {
  margin-right: 8px;

}

@media screen and (max-width: 1024px) {
  .margin-right-8px {
    margin-right: 0px;

  }

  .banner {
    img {
      width: 100%;
      border-radius: 8px;
    }
  }
}

</style>
